export const uri = {
  // 平台类目
  classfy: '/serviceCategory/selectBySelective',
  // 平台模块管理
  chunk: '/chunk/selectBySelective',
  banner: '/banner/getBannerByPurpose/',
  activity: '/communityActivity/getCommunityActivityByPage',
  // 根据类目获取相关服务
  getServiceInfoByPage: '/serviceInfo/getServiceInfoByPage',

  // 平台统计
  accessStatistics: '/itemAccess/accessStatistics'  // 获取详情进入详情统计
}



// WEBPACK FOOTER //
// ./src/api/uri/basisPlatform.js